const folderNames = {
   MASTER : "MASTER FOLDER",
   MAIN : "MAIN FOLDER",
   SUB :"SUB FOLDER",
} 

export default folderNames;


// WEBPACK FOOTER //
// ./src/constants/FolderNameConstant.js